import * as React from "react";
import { cn } from "../lib/utils";
import { Badge } from "./badge";
import { Label } from "./label";
import { RadioCardGroup, RadioCardGroupItem } from "./radio-card-group";

export interface RadioCardWithTagsOption {
  value: string;
  label: string;
  description: string;
  tags: string[];
  className?: string;
  badgeClassName?: string;
}

export interface RadioCardGroupWithTagsProps {
  options: RadioCardWithTagsOption[];
  defaultValue?: string;
  name?: string;
  className?: string;
  onValueChange?: (value: string) => void;
}

export const RadioCardGroupWithTags: React.FC<RadioCardGroupWithTagsProps> = ({
  options,
  defaultValue,
  name = "package-options",
  className,
  onValueChange,
}) => {
  return (
    <RadioCardGroup
      defaultValue={defaultValue}
      name={name}
      onValueChange={onValueChange}
      className={className}
    >
      {options.map((option) => (
        <RadioCardGroupItem
          key={option.value}
          value={option.value}
          id={option.value}
          className={cn("bg-white", option.className)}
          aria-label={`${option.label}${option.tags.length ? `, ${option.tags.join(", ")}` : ""}`}
        >
          <div className="flex flex-col items-start">
            <div className="flex flex-col gap-2 sm:flex-row">
              <Label className="text-md mb-1 cursor-pointer text-black">
                {option.label}
              </Label>
              {option.tags.length > 0 && (
                <div
                  role="list"
                  aria-label="Tags"
                  className={cn("flex flex-wrap gap-2", option.badgeClassName)}
                >
                  {option.tags.map((tag) => (
                    <Badge key={tag} variant="secondary">
                      {tag}
                    </Badge>
                  ))}
                </div>
              )}
            </div>
            <span className="text-brand-primary-regular text-base">
              {option.description}
            </span>
          </div>
        </RadioCardGroupItem>
      ))}
    </RadioCardGroup>
  );
};
